import { connect } from 'react-redux';
import CallbackJSUPPage from './CallbackJSUPPage';
import {
	getTicketTransactionById,
	resetPage,
	resetMeta
} from '../../actions/CallbackJSUPPage';

const mapsStateToProps = state => ({
	callbackJSUPPageProps: state.callbackJSUPPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getTicketTransactionById(id) {
		dispatch(getTicketTransactionById(id));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(CallbackJSUPPage);
